export const QueueStatus = {
    NOT_STARTED: 'not_started',
    QUEUED: 'queued',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    FAILED: 'failed',
};

export const finishedStatusList = [QueueStatus.FAILED, QueueStatus.COMPLETED];
